import React, { useState, useRef } from 'react'
import { Validaciones } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
import Modal from '../../../_layout/genericComponents/Modal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { RiSurveyLine } from "react-icons/ri";

import { getEncuestaCatSeccion, tablaEncuestaCatSecciones } from '../../../querys/EncuestaCatalogo';
import { upsertEncuestaCatSeccion, deleteEncuestaCatSeccion } from '../../../mutations/EncuestaCatalogo';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';

import * as Permisos from '../Permisos';
import Preguntas from './Preguntas';

const { trim } = Validaciones;

// Longitud de la columna CLAVE en tblencuesta_cat_secciones
const maxClave = 10;

function EncuestaCatalogo() {

    const { token } = useSelector(state => state.login);

    const cleanState = {
        seccionCatID: null,
        clave: "",
        descripcion: "",
        orden: "",
        activa: true
    };
    const cleanErrorState = {
        clave: { error: false, helperText: "" },
        descripcion: { error: false, helperText: "" },
        orden: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [seccionPreguntas, setSeccionPreguntas] = useState(null);

    let titleAccion = state.seccionCatID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Sección de Encuesta`;

    const claveRef = useRef(null);
    const descripcionRef = useRef(null);
    const ordenRef = useRef(null);

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "seccionCatID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: getEncuestaCatSeccion,
            formatearResultado: [{ id: "activa", formato: (data) => Number(data) === 1 }]
        })
    }, {
        accionID: [1],
        icono: ListAltIcon,
        color: success,
        descripcion: "Preguntas",
        parametros: [{ campo: "seccionCatID" }, { campo: "clave" }, { campo: "descripcion" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => setSeccionPreguntas(parametros)
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "seccionCatID" }, { campo: "clave" }],
        disabled: { multiseleccion: true },
        onClick: ({ seccionCatID, clave }) => handelAlertEliminar({
            setAlert,
            mensaje: ` la sección ${clave} con todas sus preguntas (las encuestas ya generadas no cambian)`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { seccionCatID }, asyncDelete: deleteEncuestaCatSeccion
            })
        })
    }];

    let botones = [
        {
            accionID: [2],
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        }, {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }];

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "seccionCatID",
        color: primary,
        title: "Preguntas de Encuesta",
        title2: "Secciones del cuestionario. Los cambios aplican a las encuestas que se generen después.",
        iconTable: <RiSurveyLine />,
        headers: [
            { variable: "seccionCatID", descripcion: "seccionCatID", hide: true },
            { variable: "orden", descripcion: "Orden" },
            { variable: "clave", descripcion: "Clave" },
            { variable: "descripcion", descripcion: "Descripción" },
            { variable: "preguntas", descripcion: "Preguntas" },
            { variable: "activaNombre", descripcion: "Activa" },
            { variable: "activa", descripcion: "activa", hide: true },
            { variable: "fechaModificacion", descripcion: "fechaModificacion", hide: true }
        ],
        responsiveTitle: ["clave"],
        filter: [
            { campo: "clave" },
            { campo: "descripcion" }
        ],
        alineacion: [{ columnas: [0, 1, 2, 4, 5], alineacion: "center" }, { columnas: [3], alineacion: "left" }]
    }

    const inputs = [
        {
            id: "Arriba",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: [
                {
                    disabled,
                    id: "clave",
                    value: state.clave,
                    error: errorState.clave.error,
                    success: state.clave && !errorState.clave.error ? true : undefined,
                    helperText: errorState.clave.helperText,
                    inputRef: claveRef,
                    title: "Clave *",
                    placeholder: "Ej. IV",
                    grid: { md: 4, lg: 4 },
                    onChange: ({ target: { value } }) => handleChange(value.toUpperCase(), "clave"),
                    onKeyDown: () => { return; }
                },
                {
                    disabled,
                    id: "orden",
                    value: state.orden,
                    error: errorState.orden.error,
                    success: state.orden !== "" && !errorState.orden.error ? true : undefined,
                    helperText: errorState.orden.helperText || "Vacío para agregarla al final",
                    inputRef: ordenRef,
                    title: "Orden",
                    placeholder: "Orden en la encuesta",
                    grid: { md: 4, lg: 4 },
                    onChange: ({ target: { value } }) => handleChange(value.replace(/[^0-9]/g, ""), "orden"),
                    onKeyDown: () => { return; }
                },
                {
                    disabled,
                    id: "activa",
                    value: state.activa,
                    checked: state.activa,
                    title: "Activa (se incluye al generar la encuesta)",
                    tipo: "switch",
                    grid: { md: 4, lg: 4 },
                    onChange: (e) => handleChange(e.target.checked, "activa")
                },
                {
                    disabled,
                    id: "descripcion",
                    value: state.descripcion,
                    error: errorState.descripcion.error,
                    success: state.descripcion && !errorState.descripcion.error ? true : undefined,
                    helperText: errorState.descripcion.helperText || "Se muestra en el listado de secciones de la encuesta y en el correo de envío",
                    inputRef: descripcionRef,
                    multiline: true,
                    title: "Descripción *",
                    placeholder: "Ej. IV. Facturación Anual: Millones de Pesos",
                    grid: { md: 12, lg: 12 },
                    onChange: ({ target: { value } }) => handleChange(value, "descripcion"),
                    onKeyDown: () => { return; }
                }
            ]
        }
    ];

    let accionesFormulario = [{
        accionID: state.seccionCatID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: claveRef,
            mensajeCorrecto: `La sección se ${state.seccionCatID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ clave, descripcion }) {

        let error;
        let validaciones = [
            {
                condicion: !clave || trim(clave) === "",
                ref: claveRef, keyError: "clave",
                mensajeError: "Debe especificar la clave de la sección"
            },
            {
                condicion: trim(clave).length > maxClave,
                ref: claveRef, keyError: "clave",
                mensajeError: `La clave no debe exceder de ${maxClave} caracteres`
            },
            {
                condicion: trim(clave) === "FIRMAS",
                ref: claveRef, keyError: "clave",
                mensajeError: "La clave FIRMAS está reservada para la sección de firmas"
            },
            {
                condicion: !descripcion || trim(descripcion) === "",
                ref: descripcionRef, keyError: "descripcion",
                mensajeError: "Debe especificar la descripción de la sección"
            }
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let { seccionCatID, clave, descripcion, orden, activa } = state;

            let error = await handleValidaciones({ clave, descripcion });

            if (error) return error;

            await upsertEncuestaCatSeccion({
                input: {
                    seccionCatID: seccionCatID || null,
                    clave: trim(clave),
                    descripcion: trim(descripcion),
                    orden: orden !== "" ? Number(orden) : null,
                    activa: activa ? 1 : 0
                }
            }, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={tablaEncuestaCatSecciones}
            token={token}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={claveRef}
        />
        {seccionPreguntas && <Modal maxWidth={true} open={true} onClose={() => { setSeccionPreguntas(null); setActualizar(!actualizar); }}>
            <Preguntas seccion={seccionPreguntas} accionesUsr={accionesUsr} />
        </Modal>}
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default EncuestaCatalogo;
